/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking200,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking401,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking500,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingPathParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryResponse,
} from "../../types/individualPaymentTraceabilityController/GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking.ts";
import { individualPaymentOrderTrackingViewModelSchema } from "../individualPaymentOrderTrackingViewModelSchema.ts";

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingPathParamsSchema =
  z.object({
    financialPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingPathParams>;

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryParamsSchema =
  z.object({
    culture: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking200Schema =
  z.array(
    z.lazy(() => individualPaymentOrderTrackingViewModelSchema),
  ) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking500>;

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryResponse>;
